/** 소켓으로 기다리는 기본 시간 */
export const SOCKET_WAIT_TIME = 3000

/** 소켓에서 데이터를 기다리는 기본 시간 */
export const SOCKET_WAIT_DATA_TIME = 15000

/** 주기적으로 요청해야하는 기본 간격 */
export const POLLING_INTERVAL_TIME = [2000, 4000, 6000, 8000, 12000]
